/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    currentVersion: { embedded: 'always' },
    folder: { key: 'folder_id' },
    folderMembership: { embedded: 'always' },
    contentReviewRequests: { embedded: 'always' },
    tags: { key: 'tag_ids' },
    taggings: {
      serialize: 'records',
      deserialize: 'records',
    },
  },

  serialize(snapshot: any, options: any) {
    let json = this._super(snapshot, options);

    // Include conversation_id from adapterOptions if provided
    if (snapshot.adapterOptions?.conversationId) {
      json.conversation_id = snapshot.adapterOptions.conversationId;
    }

    return json;
  },
});
